<template lang="pug">
    .account-list
        //- The tab list lives in ONE place (system/Partials/Tabs). A second copy
        //- here is how a new system page ended up missing from this bar while
        //- appearing in every page that wraps itself in the partial.
        system-tabs
            el-card.contains-table(shadow="always")
                //- router-view.account-form(:key="$route.path" :class="{'loading-panel': loading}")
                router-view.account-form
</template>

<i18n>
{
    "de": {
        "New Account": "Neuer Account",
        "Show filters": "Filter anzeigen",
        "Hide filters": "Filter verbergen",
        "Account list could not be fetched.": "Benutzerliste konnte nicht abgerufen werden."
    }
}
</i18n>

<script>
import { useSettingsStore } from '@/stores';

import SystemTabs from '@/views/system/Partials/Tabs';

export default {
    name: 'SystemAccountListe',
    components: {
        SystemTabs,
    },
    computed: {
        loading() {
            return useSettingsStore().loading;
        },
    },
};
</script>

<style lang="sass" scoped>
.el-button--medium.is-circle
    padding: 5px

.mimic-button
    &[disabled]
        pointer-events: none
    &:not([disabled]):hover
        background: $--color-primary
        border-color: $--color-primary

.account-list
    :deep()
        .column.name
            position: relative
            .is-owner
                font-size: 0.6rem
                position: absolute
                color: $--color-primary
                top: 0
                left: -10px
                // i
                //     padding: 3px
                //     border-radius: 50%
                //     background: $ci-color-primary
</style>
